<template>
  <div>
    <!-- EXCEPTED QUANTITY FIELDS -->
    <div class="col-xs-12 m-b-30">
      <div class="d-inline-block m-r-20" v-if="!value.isLimitedQuantity">
        <Toggle
          class="m-r-10"
          :id="`is-eq-${colliId}-${indexInData}`"
          :label="$t('excepted_quantity')"
          v-model="value.isExceptedQuantity"
          @change="onChangeExceptedQuantity"
        />
        {{ $t('excepted_quantity') }}
      </div>
      <div class="d-inline-block m-r-20" v-if="!value.isExceptedQuantity">
        <Toggle
          class="m-r-10"
          :id="`is-lq-${colliId}-${indexInData}`"
          :label="$t('limited_quantity')"
          v-model="value.isLimitedQuantity"
          @change="onChangeLimitedQuantity"
        />
        {{ $t('limited_quantity') }}
      </div>
      <!-- ENV HAZARD -->
      <div v-if="shouldShowEnvHazardToggle && !value.isLimitedQuantity && !value.isExceptedQuantity && !shouldShowMarinePollutantToggle" class="d-inline-block">
        <Toggle
          class="m-r-10"
          :id="`is-env-hazard-${colliId}-${indexInData}`"
          :label="$t('is_environmental_hazard')"
          v-model="value.isEnvironmentalHazard" />
        {{ $t('is_environmental_hazard') }}
      </div>
      <div v-if="shouldShowMarinePollutantToggle" class="d-inline-block">
        <Toggle
          class="m-r-10"
          :id="`is-marin_pollutant-${colliId}-${indexInData}`"
          :label="$t('is_marine_pollutant')"
          v-model="value.isMarinePollutant" />
        {{ $t('is_marine_pollutant') }}
      </div>
    </div>
    <!-- ADR - LIMITED QUANTITY FIELDS -->
    <div class="col-xs-12">
      <message class="m-b-20" v-if="lqHasErrors" name="warning" :data="{data: lqErrorMsg, type:'validation'}"></message>
      <message class="m-b-20" v-if="eqHasErrors" name="warning" :data="{data: eqErrorMsg, type:'validation'}"></message>
    </div>
    <div class="m-b-40 clear-float" v-if="value.isExceptedQuantity">
      <div class="col-xs-6">
        <InputSelect
          :label="$t('un_number')"
          v-model="value.dangerousGoodsId"
          :options="dangerousGoodsOptions"
          @change="onChangeEqUnCode"
          :rules="{required: true}" />
      </div>
      <div class="col-xs-3">
        <WeightSelect
          :selectionType="'dangerous_goods'"
          :label="$t('net_weight')"
          v-model="value.netWeight"
        />
      </div>
      <div class="col-xs-3">
        <WeightSelect
          :selectionType="'dangerous_goods'"
          :label="$t('brutto_weight')"
          v-model="value.bruttoWeight"
          @input="onChangeEqWeight"
          :rules="{required: true}"
        />
      </div>
    </div>
    <div>
    <div class="m-b-40 clear-float" v-if="value.isLimitedQuantity">
      <div class="col-xs-6">
        <InputSelect
          :label="$t('un_number')"
          v-model="value.dangerousGoodsId"
          :options="dangerousGoodsOptions"
          @change="onChangeLqUnCode"
          :rules="{required: true}" />
      </div>
      <div class="col-xs-3">
        <WeightSelect
          :selectionType="'dangerous_goods'"
          :label="$t('net_weight')"
          v-model="value.netWeight"
        />
      </div>
      <div class="col-xs-3">
        <WeightSelect
          :selectionType="'dangerous_goods'"
          :label="$t('brutto_weight')"
          v-model="value.bruttoWeight"
          @input="onChangeLqWeight"
          :rules="{required: true}"
        />
    </div>
      </div>
      <div class="clear-float m-b-40"  v-if="isADR && goodsType === 3">
        <div class="col-xs-6">
          <InputText
            :label="$t('outer_qty')"
            v-model="value.notAllInOneQty"
            :rules="{required: true}"/>
        </div>
        <div class="col-xs-6">
          <InputSelect
            :label="$t('outer_packaging')"
            v-model="value.notAllInOneOuterPackaging"
            :options="getDangerousGoodsPackingTypeOptions"
            :rules="{required: true}" />
        </div>
      </div>
    </div>
    <!-- ADR, IATA, IMDG - DANGEROUS GOODS FIELDS -->
    <div v-if="!value.isLimitedQuantity && !value.isExceptedQuantity && !isWithoutDoc">
      <div class="clear-float m-b-30">
        <div :class="classUnNumber">
          <InputSelect
            :label="$t('un_number')"
            v-model="value.dangerousGoodsId"
            @change="setDGOptionData"
            :options="dangerousGoodsOptions"
            :rules="{required: true}" />
        </div>
        <div class="col-xs-3" v-if="isIATA">
          <InputText
            :label="$t('packing_inst')"
            v-model="value.packingInstruction"
            :rules="{required: true}" />
        </div>
        <div v-if="isHazardClass1" class="col-xs-2">
          <WeightSelect
            :selectionType="'nem_weight'"
            :label="$t('nem_weight')"
            v-model="value.nemWeight"
            :rules="{required: true}" />
        </div>
        <div class="col-xs-2">
          <WeightSelect
            :selectionType="'dangerous_goods'"
            :label="$t('brutto_weight')"
            v-model="value.bruttoWeight"
            :rules="{required: true}" />
        </div>
        <div class="col-xs-2">
          <WeightSelect
              :selectionType="'dangerous_goods'"
              :label="$t('net_weight')"
              v-model="value.netWeight"
              :rules="{required: true}" />
        </div>
      </div>
      <div class="clear-float m-b-30">
        <div :class="classOuterPack" v-if="goodsType === 3 && parseInt(allPackedInOne) === 2" >
          <InputText
              :label="$t('outer_qty')"
              v-model="value.notAllInOneQty"
              :rules="{required: true}"/>
        </div>
        <div :class="classOuterPack" v-if="parseInt(allPackedInOne) === 2" >
          <InputSelect
              :label="$t('outer_packaging')"
              v-model="value.notAllInOneOuterPackaging"
              :options="getDangerousGoodsPackingTypeOptions"
              :rules="{required: true}" />
        </div>
        <div :class="classInnerPack" v-if="showInnerQtyAndPackaging">
          <InputText
              :label="$t('inner_qty')"
              v-model="value.innerPackagingQty"
              :rules="{required: true}"/>
        </div>
        <div :class="classInnerPack" v-if="showInnerQtyAndPackaging">
          <InputText
              :label="$t('inner_packaging')"
              v-model="value.innerPackaging"
              :rules="{required: true}"/>
        </div>
      </div>
      <div class="clear-float m-b-30">
        <div :class="classAdditionalFields" v-if="isFlashPoint && isIMDG">
          <InputText
            :label="$t('flash_point')"
            v-model="value.flashPoint"
            :rules="{required: true}" />
        </div>
        <div class="col-xs-2" v-if="value.dangerousGoodsId && isIMDG && !isSegregationGroupDisabled && !isWithoutDoc">
          <InputSelect
            :label="$t('segregation_group')"
            v-model="value.segregationGroup"
            :disabled="isSegregationGroupDisabled"
            :options="segregationGroupOptions"
            :rules="{required: false}" />
        </div>
        <div :class="classAdditionalFields" v-if="isIMDG">
          <InputText
            :label="$t('EmS')"
            v-model="value.ems"
            :rules="{required: false}" />
        </div>
        <div v-if="isNOS">
          <div :class="techDesigClass">
            <InputText
                :label="$t('technical_designation_international')"
                v-model="value.englishTechnicalDesignation"
                :rules="{required: true}" />
          </div>
          <div :class="techDesigClass">
            <InputText
                :label="$t('technical_designation_national')"
                v-model="value.danishTechnicalDesignation"
                :rules="{required: true}" />
          </div>
         </div>
        <div :class="classAutorization" v-if="isIATA">
          <InputText
              :label="$t('iata_autorization')"
              v-model="value.iataAutorization"
              :rules="{required: false}" />
        </div>
        </div>
    </div>
    <!-- Without document section -->
    <div class="clear-float" v-if="isWithoutDoc && !value.isLimitedQuantity && !value.isExceptedQuantity ">
      <div class="col-xs-6">
        <InputSelect
          :label="$t('un_number')"
          v-model="value.dangerousGoodsId"
          :options="dangerousGoodsOptions"
          :rules="{required: true}" />
      </div>
      <div class="col-xs-3">
        <WeightSelect
          :selectionType="'dangerous_goods'"
          :label="$t('net_weight')"
          v-model="value.netWeight"
        />
      </div>
      <div class="col-xs-3">
        <WeightSelect
          :selectionType="'dangerous_goods'"
          :label="$t('brutto_weight')"
          v-model="value.bruttoWeight"
          :rules="{required: true}"
        />
      </div>
    </div>
    <div class="clear-float m-l-10">
      <Btn
        v-if="deletable"
        @click.native="deleteDgRow"
        class="gray float-left m-r-20"
        :icon="{
            name: 'deleteForever',
            size: '18',
          }"
        :btnText="$t('remove_dg_block')"
      />
    </div>
    <div class="separator" style="width: 100%"></div>
  </div>
</template>

<script>
/* eslint-disable */
import InputText from '@/components/elements/inputs/text.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import mixin from "@/mixins/mixins";
import Btn from "@/components/elements/buttons/button";
import Toggle from "@/components/elements/inputs/toggle";
import DimensionsSelect from "@/components/elements/inputs/dimensionsSelect";
import WeightSelect from "@/components/elements/inputs/weightSelect";
import NestedSelect from "@/components/elements/inputs/nestedSelect";
import {mapGetters} from "vuex";
import {is} from "date-fns/locale";

export default {
  name: 'DangerousGoodsRow',
  mixins: [mixin],
  components: {
    Btn,
    InputSelect,
    InputText,
    Toggle,
    DimensionsSelect,
    WeightSelect,
    NestedSelect,
  },
  props: {
    goodsType: {
      type: Number,
      default: 1
    },
    indexInData: {
      type: Number,
      default: 1
    },
    deletable: {
      type: Boolean,
      default: false
    },
    colliId: {
      type: String,
      default: ''
    },
    serviceCategory: {
      type: [Number, String],
      default: ''
    },
    feeWrapperId: {
      type: [Number, String],
      default: ''
    },
    packingTypeOption: {
      type: [Number, String],
      default: ''
    },
    allPackedInOne: {
      type: [Number, String],
      default: ''
    },
    value: {
      type: Object,
      default: () => {
        return {
          feeWrapperId: null,
          dangerousGoodsId: '',
          notAllInOneQty: '',
          notAllInOneOuterPackaging: '',
          nemWeight: {
            unit: 'kg',
            value: null,
          },
          netWeight: {
            unit: 'kg',
            value: null,
          },
          bruttoWeight: {
            unit: 'kg',
            value: null,
          },
          englishTechnicalDesignation: '',
          danishTechnicalDesignation: '',
          iataAutorization: '',
          flashPoint: '',
          segregationGroup: '',
          ems: '',
          innerPackaging: '',
          innerPackagingQty: '',
          packingInstruction: '',
          isEnvironmentalHazard: false,
          isMarinePollutant: false,
          isLimitedQuantity: false,
          isExceptedQuantity: false
        }
      },
    },
  },
  data() {
    return {
      isNOS: false,
      isFlashPoint: false,
      isIMDG: false,
      isIATA: false,
      isADR: false,
      isWithoutDoc: false,
      isHazardClass1: false,
      shouldShowEnvHazardToggle: false,
      shouldShowMarinePollutantToggle: false,
      isSegregationGroupDisabled: false,
      lqHasErrors: false,
      eqHasErrors: false,
      lqErrorMsg: '',
      eqErrorMsg: '',
      dangerousGoodsOptions: [], //Un codes
      segregationGroupOptions: []
    }
  },
  computed: {
    ...mapGetters([
      'get_parcel_types',
      'get_dangerous_goods_options',
      'get_dangerous_goods_option_by_id',
      'get_dangerous_goods_service_by_id',
      'get_dangerous_goods_options_by_type',
      'get_dangerous_goods_types',
      'get_dangerous_goods_packing_types'
    ]),
    showInnerQtyAndPackaging() {
      return (parseInt(this.packingTypeOption) === 1) && (parseInt(this.allPackedInOne) === 2);
    },
    getDangerousGoodsPackingTypeOptions() {
      return this.get_dangerous_goods_packing_types.map((type) => {
        return {text: this.$t(type), value: type}
      });
    },
    classAdditionalFields(){
      //SegregationGroup field is shown
      if (this.value.dangerousGoodsId && this.isIMDG && !this.isSegregationGroupDisabled) {
        return 'col-xs-10';
      } else if (this.isIMDG && !this.isNOS && !this.isFlashPoint) {
        return 'col-xs-12';
      }  else if(this.isIMDG && !this.isNOS && this.isFlashPoint) {
        return 'col-xs-6'
      }  else if(this.isIATA) {
        return 'col-xs-3'
      }  else {
        return 'col-xs-2';
      }
    },
    classUnNumber() {
      if (this.isHazardClass1 && parseInt(this.allPackedInOne) === 2 && !this.isIATA) {
        //console.log('nem i all pack No')
        return 'col-xs-6'
      } else if(this.isHazardClass1 && parseInt(this.allPackedInOne) === 1 && !this.isIATA) {
        //console.log('nem i all pack Yes')
        return 'col-xs-6'
      } else if(!this.isHazardClass1 && parseInt(this.allPackedInOne) === 2 && !this.isIATA) {
        //console.log('nije nem i all pack No')
        return 'col-xs-8'
      } else if(this.isHazardClass1 && parseInt(this.packingTypeOption) === 1) {
        //console.log('nem i pack type option combination')
        return 'col-xs-3'
      } else if(parseInt(this.packingTypeOption) === 2 && !this.isIATA) {
        //console.log('pack type option single i nije IATA ')
        return 'col-xs-8'
      } else if(!this.isHazardClass1 && this.isIATA) {
        //console.log('nije nem i IATA je')
        return 'col-xs-5'
      } else if(this.isHazardClass1 && this.isIATA) {
        //console.log('nem i IATA je')
        return 'col-xs-3'
      } else if(this.isHazardClass1 && this.packingTypeOption == '') {
        //console.log('nem i pack iz prazan')
        return 'col-xs-6'
      } else {
        //console.log('nije nista od navedenog')
        return "col-xs-8"
      }
    },
    techDesigClass() {
        if (this.isNOS && !this.isIMDG && !this.isIATA) {
          return 'col-xs-6'
        } else if (this.isFlashPoint) {
          return 'col-xs-4'
        }  else if (this.isIATA) {
          return 'col-xs-4'
        } else {
          return 'col-xs-5'
        }
    },
    classInnerPack() {
      if (parseInt(this.packingTypeOption) === 1 && parseInt(this.allPackedInOne) === 2) {
        return 'col-xs-3'
      } else{
        return 'col-xs-6'
      }
    },
    classOuterPack() {
      if (this.goodsType === 3 && parseInt(this.packingTypeOption) === 1 && parseInt(this.allPackedInOne) === 2) {
        return 'col-xs-3'
      } else if (this.goodsType !== 3 && parseInt(this.packingTypeOption) === 1 && parseInt(this.allPackedInOne) === 2) {
        return 'col-xs-6'
      } else if (this.goodsType !== 3) {
        //here we dont show qty
        return 'col-xs-12'
      } else {
        return 'col-xs-6'
      }
    },
    classAutorization() {
      if (this.isIATA && this.isNOS) {
        return 'col-xs-4'
      } else {
        return 'col-xs-12'
      }
    }
  },
  mounted () {
    //When we already have data we need to set it on component, eg. draft or copy to new shipment
    this.value.feeWrapperId = this.feeWrapperId;
    if (this.value.feeWrapperId) {
      this.setDGServiceData(this.serviceCategory);
    }
    if (this.value.dangerousGoodsId) {
      this.setDGOptionData(this.value.dangerousGoodsId);
    }
  },
  methods: {
    resolveSegregationGroupStuff(dg) {
      if (!dg) return;
      if (dg.segregation_groups && dg.segregation_groups.length > 1) {
        this.segregationGroupOptions = dg.segregation_groups.map((item) => {
          return {value: item, text: item}
        });
        this.value.segregationGroup = '';
        this.isSegregationGroupDisabled = false;
      } else if (dg.segregation_groups && dg.segregation_groups.length == 1) {
        this.value.segregationGroup = dg.segregation_groups[0];
        this.isSegregationGroupDisabled = true;
        this.segregationGroupOptions = [];
      } else {
        this.value.segregationGroup = '';
        this.isSegregationGroupDisabled = true;
        this.segregationGroupOptions = [];
      }
    },
    setDangerousGoodsOptions(isLq, isEq) {
      if (!this.serviceCategory) {
        this.dangerousGoodsOptions = [];
        return;
      }

      //Un codes and other stuff
      if (this.serviceCategory) {
        const type = this.get_dangerous_goods_types[this.serviceCategory];
        this.dangerousGoodsOptions = this.get_dangerous_goods_options_by_type(type, isLq, isEq);
      }
    },
    setDGServiceData (serviceCategory) {
      //28 = Adr - Dangerous Goods, 29 = IATA - dg, 30 - IMDG - dg
      this.shouldShowEnvHazardToggle = ['28', '29', '31'].includes(serviceCategory);
      this.shouldShowMarinePollutantToggle = ['30'].includes(serviceCategory);
      this.isIMDG = parseInt(this.serviceCategory) === 30;
      this.isIATA = parseInt(this.serviceCategory) === 29;
      this.isADR = parseInt(this.serviceCategory) === 28;
      this.isWithoutDoc = parseInt(this.serviceCategory) === 32;
      this.setDangerousGoodsOptions(this.value.isLimitedQuantity);
    },
    deleteDgRow(index) {
      this.$emit('deleteRow', index);
    },
    setDGOptionData(val) {
      const dg = this.get_dangerous_goods_option_by_id(val);
      this.isHazardClass1 = parseInt(dg.hazard_class) === 1;
      this.isNOS = dg.nos;
      this.isFlashPoint = dg.flash_point;
      this.resolveSegregationGroupStuff(dg);
    },
    //Limited quantity
    onChangeLimitedQuantity(val) {
      this.checkLimitedQuantityError(
        val,
        this.value.dangerousGoodsId,
        this.value.bruttoWeight
      );

      this.setDangerousGoodsOptions(val, false);
    },
    onChangeLqUnCode(val) {
      this.checkLimitedQuantityError(
        this.value.isLimitedQuantity,
        val,
        this.value.bruttoWeight
      );

      this.setDGOptionData(val);
    },
    onChangeLqWeight(weight) {
      this.checkLimitedQuantityError(
        this.value.isLimitedQuantity,
        this.value.dangerousGoodsId,
        weight
      );
    },
    checkLimitedQuantityError(isLq, dgId, weight) {
      if (!isLq) {
        this.lqHasErrors = false;
        this.lqErrorMsg = '';
        return;
      }

      if (!dgId) {
        this.lqHasErrors = false;
        this.lqErrorMsg = '';
        return;
      }

      const dg = this.get_dangerous_goods_option_by_id(dgId);

      let compareValue = dg.lq_limit;
      if (compareValue && ['g', 'ml'].includes(dg.lq_limit_unit)) {
        //Convert to kg/liter
        compareValue = (compareValue / 1000).toFixed(2);
      }

      this.lqHasErrors = !!(compareValue && weight.value && (compareValue < Number(weight.value.toString().replace(',', '.'))));

      if (this.lqHasErrors) {
        this.lqErrorMsg = this.$t('lq_dg_error', {
          'lq_limit': dg.lq_limit,
          'lq_limit_unit': this.$t(dg.lq_limit_unit),
          'un_number': dg.un_code
        });
      }
    },
    //Excepted Quantity
    onChangeExceptedQuantity(val) {
      this.checkExceptedQuantityError(
        val,
        this.value.dangerousGoodsId,
        this.value.bruttoWeight
      );

      this.setDangerousGoodsOptions(false, val );
    },
    onChangeEqUnCode(val) {
      this.checkExceptedQuantityError(
        this.value.isExceptedQuantity,
        val,
        this.value.bruttoWeight
      );

      this.setDGOptionData(val);
    },
    onChangeEqWeight(weight) {
      this.checkExceptedQuantityError(
        this.value.isExceptedQuantity,
        this.value.dangerousGoodsId,
        weight
      );
    },
    checkExceptedQuantityError(isEq, dgId, weight) {
      if (!isEq) {
        this.eqHasErrors = false;
        this.eqErrorMsg = '';
        return;
      }

      if (!dgId) {
        this.eqHasErrors = false;
        this.eqErrorMsg = '';
        return;
      }

      const dg = this.get_dangerous_goods_option_by_id(dgId);
      let compareValue = dg.eq_outer_limit;
      if (compareValue && ['g', 'ml'].includes(dg.eq_limit_unit)) {
        //Convert to kg/liter
        compareValue = (compareValue / 1000).toFixed(2);
      }

      this.eqHasErrors = !!(compareValue && weight.value && (compareValue < Number(weight.value.toString().replace(',', '.'))));

      if (this.eqHasErrors) {
        this.eqErrorMsg = this.$t('eq_dg_error', {
          'eq_inner_limit': dg.eq_inner_limit,
          'eq_outer_limit': dg.eq_outer_limit,
          'eq_limit_unit': this.$t(dg.eq_limit_unit),
          'un_number': dg.un_code
        });
      }
    }
  },
  watch: {
    'serviceCategory'(newVal, oldVal) {
      if(newVal !== oldVal) {
        this.setDGServiceData(newVal);
      }
    },
    'feeWrapperId'(newVal, oldVal) {
      if(newVal !== oldVal) {
        this.value.feeWrapperId = newVal;
      }
    },
  },
}
</script>
